import * as React from "react";
import styled from "styled-components";

import Icon from "../../common/components/Icon";
import Hover from "../../common/components/Hover";

interface Props {
  editable?: boolean;
  editLink?: string;
  onClick?: () => void;
}

const EditableCardWrapper: React.SFC<Props> = props => {
  const { editable, editLink, onClick, children } = props;
  return (
    <Hover>
      {({ isHovered, ref }) => (
        <Base innerRef={ref}>
          {editable &&
            (editLink ? (
              <EditLinkWrapper hover={isHovered}>
                <EditLink href={editLink} target="_blank">
                  <Icon name="wt-icon-pencil" />
                </EditLink>
              </EditLinkWrapper>
            ) : (
              <EditButtonWrapper hover={isHovered} onClick={onClick}>
                <Icon name="wt-icon-pencil" />
              </EditButtonWrapper>
            ))}
          {children}
        </Base>
      )}
    </Hover>
  );
};

EditableCardWrapper.defaultProps = {
  editable: true,
};

const Base = styled.div`
  position: relative;
`;

const EditLinkWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: white;
  color: rgba(0, 0, 0, 0.4);
  font-size: 13px;
  visibility: ${(props: { hover: boolean }) => (props.hover ? "visible" : "hidden")};
  opacity: ${(props: { hover: boolean }) => (props.hover ? 1 : 0)};
  transition: visibility 150ms, opacity 150ms;
  cursor: pointer;
  z-index: 1;
  &:hover {
    opacity: 0.8;
  }
`;

const EditLink = styled.a`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.4);
`;

const EditButtonWrapper = EditLinkWrapper.extend`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default EditableCardWrapper;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/EditableCardWrapper.tsx